<template>
  <div class="my-resource-store-manage-container">
    <ds-page-header :title="$t('myResourceStoreManage.page.title')"
      :subtitle="$t('myResourceStoreManage.page.subtitle')">
      <template #extra>
        <el-button size="small" icon="el-icon-download" @click="_exportMyResourceStore">
          {{ $t('myResourceStoreManage.export') }}
        </el-button>
        <el-button type="primary" size="small" icon="el-icon-refresh" @click="_queryResourceStoreMethod">
          {{ $t('common.refresh') }}
        </el-button>
      </template>
    </ds-page-header>

    <ds-search-panel>
      <el-row :gutter="16">
        <el-col :span="6">
          <el-input v-model="myResourceStoreManageInfo.conditions.resId"
            :placeholder="$t('myResourceStoreManage.enterResId')" clearable />
        </el-col>
        <el-col :span="6">
          <el-input v-model="myResourceStoreManageInfo.conditions.resName"
            :placeholder="$t('myResourceStoreManage.enterResName')" clearable />
        </el-col>
        <el-col :span="6">
          <el-input v-model="myResourceStoreManageInfo.conditions.resCode"
            :placeholder="$t('myResourceStoreManage.enterResCode')" clearable />
        </el-col>
        <el-col :span="6">
          <el-select v-model="myResourceStoreManageInfo.conditions.isFixed"
            :placeholder="$t('myResourceStoreManage.selectIsFixed')" style="width:100%" clearable>
            <el-option v-for="(item,index) in myResourceStoreManageInfo.isFixeds" :key="index"
              :label="item.name" :value="item.statusCd" />
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="16" v-show="myResourceStoreManageInfo.moreCondition" style="margin-top:16px;">
        <el-col :span="6">
          <el-select v-model="myResourceStoreManageInfo.conditions.parentRstId"
            :placeholder="$t('myResourceStoreManage.selectResType')" style="width:100%"
            @change="_listResourceStoreSonTypes" clearable>
            <el-option v-for="(item,index) in myResourceStoreManageInfo.resourceStoreTypes" :key="index"
              :label="item.name" :value="item.rstId" />
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-select v-model="myResourceStoreManageInfo.conditions.rstId"
            :placeholder="$t('myResourceStoreManage.selectSecondType')" style="width:100%"
            @change="_listResourceStoreSpecifications" clearable>
            <el-option v-for="(item,index) in myResourceStoreManageInfo.resourceStoreSonTypes" :key="index"
              :label="item.name" :value="item.rstId" />
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-select v-model="myResourceStoreManageInfo.conditions.rssId"
            :placeholder="$t('myResourceStoreManage.selectResSpec')" style="width:100%" clearable>
            <el-option v-for="(item,index) in myResourceStoreManageInfo.resourceStoreSpecifications" :key="index"
              :label="item.specName" :value="item.rssId" />
          </el-select>
        </el-col>
        <el-col :span="6" v-if="hasPrivilege('502021071018550002')">
          <el-input v-model="myResourceStoreManageInfo.conditions.searchUserId"
            :placeholder="$t('myResourceStoreManage.enterUserId')" clearable />
        </el-col>
      </el-row>
      <el-row :gutter="16" v-show="myResourceStoreManageInfo.moreCondition && hasPrivilege('502021071018550002')"
        style="margin-top:16px;">
        <el-col :span="6">
          <el-input v-model="myResourceStoreManageInfo.conditions.searchUserName"
            :placeholder="$t('myResourceStoreManage.enterUserName')" clearable />
        </el-col>
      </el-row>
      <template #actions>
        <el-button type="primary" size="small" icon="el-icon-search" @click="_queryResourceStoreMethod">
          {{ $t('myResourceStoreManage.search') }}
        </el-button>
        <el-button size="small" icon="el-icon-refresh" @click="_resetResourceStoreMethod">
          {{ $t('myResourceStoreManage.reset') }}
        </el-button>
        <el-button size="small" type="text" @click="_moreCondition">
          {{ myResourceStoreManageInfo.moreCondition ? $t('myResourceStoreManage.hide') : $t('myResourceStoreManage.more') }}
          <i :class="myResourceStoreManageInfo.moreCondition ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
        </el-button>
      </template>
    </ds-search-panel>

    <div class="ds-panel">
      <ds-toolbar :total="page.total" :density="density" :show-column-setting="false"
        @update:density="density = $event" @refresh="_listResourceStores(page.current, page.size)">
        <template #left>
          <span class="ds-panel__title">{{ $t('myResourceStoreManage.myResources') }}</span>
        </template>
        <template #right>
          <el-button type="primary" size="mini" icon="el-icon-circle-close" @click="_jump2ReturnGoodsPage">
            {{ $t('myResourceStoreManage.return') }}
          </el-button>
          <el-button type="primary" size="mini" icon="el-icon-share" @click="_jump2TransferGoodsPage">
            {{ $t('myResourceStoreManage.transfer') }}
          </el-button>
          <el-button type="primary" size="mini" icon="el-icon-delete" @click="_jump2ScrapGoodsPage">
            {{ $t('myResourceStoreManage.scrap') }}
          </el-button>
          <el-button size="mini" icon="el-icon-download" @click="_exportMyResourceStore">
            {{ $t('myResourceStoreManage.export') }}
          </el-button>
        </template>
      </ds-toolbar>
      <ds-data-table :data="myResourceStoreManageInfo.resourceStores" :loading="loading" :error="hasError"
        :error-message="errorMessage" :density="density" border
        :empty-description="$t('myResourceStoreManage.page.empty')"
        @retry="_listResourceStores(page.current, page.size)">
        <el-table-column v-if="hasPrivilege('502021071018550002')" prop="userId"
          :label="$t('myResourceStoreManage.userId')" align="center" width="110">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.userId || '-' }}</span></template>
        </el-table-column>
        <el-table-column v-if="hasPrivilege('502021071018550002')" prop="userName"
          :label="$t('myResourceStoreManage.userName')" align="center" width="110" />
        <el-table-column prop="resId" :label="$t('myResourceStoreManage.resId')" align="center" width="110">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.resId || '-' }}</span></template>
        </el-table-column>
        <el-table-column :label="$t('myResourceStoreManage.resType')" align="center" min-width="140">
          <template slot-scope="scope">
            {{ scope.row.parentRstName || '-' }} &gt; {{ scope.row.rstName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="resName" :label="$t('myResourceStoreManage.resName')" align="center" min-width="130" />
        <el-table-column prop="specName" :label="$t('myResourceStoreManage.resSpec')" align="center" width="110">
          <template slot-scope="scope">{{ scope.row.specName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="resCode" :label="$t('myResourceStoreManage.resCode')" align="center" width="130">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.resCode || '-' }}</span></template>
        </el-table-column>
        <el-table-column prop="isFixedName" :label="$t('myResourceStoreManage.isFixed')" align="center" width="110">
          <template slot-scope="scope">
            <ds-status-tag size="sm" type="info" :label="scope.row.isFixedName || '-'" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('myResourceStoreManage.stock')" align="center" width="120">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.stock }}{{ scope.row.unitCodeName }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('myResourceStoreManage.miniStock')" align="center" width="130">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.miniStock }}{{ scope.row.miniUnitCodeName }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('myResourceStoreManage.miniUnit')" align="center" min-width="150">
          <template slot-scope="scope">
            <span class="ds-num">1{{ scope.row.unitCodeName }}={{ scope.row.miniUnitStock }}{{ scope.row.miniUnitCodeName }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('myResourceStoreManage.price')" align="center" min-width="140">
          <template slot-scope="scope">
            <span class="ds-num">{{ formatPrice(scope.row) }}</span>
          </template>
        </el-table-column>
      </ds-data-table>
      <ds-pagination-bar :page="page.current" :size="page.size" :total="page.total"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
import { listUserStorehouses, listResourceStoreTypes, listResourceStoreSpecifications, exportData } from '@/api/resource/myResourceStoreManageApi'
import { getDict } from '@/api/community/communityApi'
import { getCommunityId } from '@/api/community/communityApi'
import { getUserId, getUserName } from '@/api/user/userApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsSearchPanel from '@/components/ds/ds-search-panel.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'
import DsPaginationBar from '@/components/ds/ds-pagination-bar.vue'
import DsStatusTag from '@/components/ds/ds-status-tag.vue'

export default {
  name: 'MyResourceStoreManageList',
  components: { DsPageHeader, DsSearchPanel, DsToolbar, DsDataTable, DsPaginationBar, DsStatusTag },
  data() {
    return {
      loading: false,
      hasError: false,
      errorMessage: '',
      density: 'default',
      myResourceStoreManageInfo: {
        resourceStores: [],
        total: 0,
        records: 1,
        moreCondition: false,
        isFixeds: [],
        conditions: {
          resId: '',
          resName: '',
          resCode: '',
          parentRstId: '',
          rstId: '',
          rssId: '',
          searchUserName: '',
          searchUserId: '',
          isFixed: '',
          userId: getUserId(),
          userName: getUserName(),
          communityId: ''
        },
        resourceStoreTypes: [],
        resourceStoreSonTypes: [],
        resourceStoreSpecifications: []
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  created() {
    this.myResourceStoreManageInfo.conditions.communityId = getCommunityId()
    this._initMethod()
  },
  methods: {
    async _initMethod() {
      await this._listResourceStores(this.page.current, this.page.size)
      await this._listResourceStoreTypes()
      await this._listResourceStoreSpecifications()
      await this.getDictData()
    },
    async getDictData() {
      try {
        const data = await getDict('resource_store', 'is_fixed')
        this.myResourceStoreManageInfo.isFixeds = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    async _listResourceStores(page, size) {
      try {
        this.loading = true
        this.hasError = false
        const params = {
          ...this.myResourceStoreManageInfo.conditions,
          page,
          row: size
        }
        const res = await listUserStorehouses(params)
        this.myResourceStoreManageInfo.resourceStores = res.data
        this.page.total = res.total
      } catch (error) {
        console.error('获取物品列表失败:', error)
        this.hasError = true
        this.errorMessage = this.$t('common.loadError')
      } finally {
        this.loading = false
      }
    },
    formatPrice(row) {
      if (row.outHighPrice === row.outLowPrice) {
        return '￥' + row.outLowPrice
      }
      return '￥' + row.outLowPrice + '-￥' + row.outHighPrice
    },
    _queryResourceStoreMethod() {
      this.page.current = 1
      this._listResourceStores(this.page.current, this.page.size)
    },
    _resetResourceStoreMethod() {
      this.myResourceStoreManageInfo.conditions = {
        ...this.myResourceStoreManageInfo.conditions,
        resId: '',
        resName: '',
        resCode: '',
        rstId: '',
        parentRstId: '',
        rssId: '',
        searchUserId: '',
        searchUserName: '',
        isFixed: ''
      }
      this.myResourceStoreManageInfo.resourceStoreSonTypes = []
      this.myResourceStoreManageInfo.resourceStoreSpecifications = []
      this.page.current = 1
      this._listResourceStores(this.page.current, this.page.size)
    },
    _moreCondition() {
      this.myResourceStoreManageInfo.moreCondition = !this.myResourceStoreManageInfo.moreCondition
    },
    async _listResourceStoreTypes() {
      try {
        const params = {
          page: 1,
          row: 100,
          communityId: this.myResourceStoreManageInfo.conditions.communityId,
          parentId: '0'
        }
        const res = await listResourceStoreTypes(params)
        this.myResourceStoreManageInfo.resourceStoreTypes = res.data
      } catch (error) {
        console.error('获取物品类型失败:', error)
      }
    },
    async _listResourceStoreSonTypes() {
      this.myResourceStoreManageInfo.conditions.rstId = ''
      this.myResourceStoreManageInfo.resourceStoreSonTypes = []
      if (!this.myResourceStoreManageInfo.conditions.parentRstId) return
      try {
        const params = {
          page: 1,
          row: 100,
          communityId: this.myResourceStoreManageInfo.conditions.communityId,
          parentId: this.myResourceStoreManageInfo.conditions.parentRstId
        }
        const res = await listResourceStoreTypes(params)
        this.myResourceStoreManageInfo.resourceStoreSonTypes = res.data
      } catch (error) {
        console.error('获取二级分类失败:', error)
      }
    },
    async _listResourceStoreSpecifications() {
      this.myResourceStoreManageInfo.resourceStoreSpecifications = []
      this.myResourceStoreManageInfo.conditions.rssId = ''
      if (!this.myResourceStoreManageInfo.conditions.rstId) return
      try {
        const params = {
          page: 1,
          row: 100,
          communityId: this.myResourceStoreManageInfo.conditions.communityId,
          rstId: this.myResourceStoreManageInfo.conditions.rstId
        }
        const res = await listResourceStoreSpecifications(params)
        this.myResourceStoreManageInfo.resourceStoreSpecifications = res.data
      } catch (error) {
        console.error('获取物品规格失败:', error)
      }
    },
    _jump2TransferGoodsPage() {
      this.$router.push('/pages/common/transferGoodsManage')
    },
    _jump2ScrapGoodsPage() {
      this.$router.push('/pages/common/scrapGoodsStep')
    },
    _jump2ReturnGoodsPage() {
      this.$router.push('/pages/common/returnStorehouseApplyManage')
    },
    async _exportMyResourceStore() {
      try {
        const params = {
          ...this.myResourceStoreManageInfo.conditions,
          pagePath: 'myResourceStoreManage'
        }
        const res = await exportData(params)
        this.$message.success(res.msg)
        if (res.code === 0) {
          this.$router.push('/pages/property/downloadTempFile?tab=下载中心')
        }
      } catch (error) {
        console.error('导出失败:', error)
      }
    },
    handleSizeChange(val) {
      this.page.size = val
      this._listResourceStores(this.page.current, this.page.size)
    },
    handleCurrentChange(val) {
      this.page.current = val
      this._listResourceStores(this.page.current, this.page.size)
    }
  }
}
</script>

<style lang="scss" scoped>
.my-resource-store-manage-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-lg);
  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }
}
</style>
